export const titles = {
    frontGeneral: "Solicitudes Proyecto T",
    frontClients: "Listado de solicitudes de firmas electrónicas",
    frontVerification: "Estado de solicitudes",
    frontVerificationValidation: "Verificar Solicitud",
    frontMyself: "Solicitudes aliados",
    frontElectronics: "Certificados electrónicos",
    frontRoles: "Listado de Roles",
    frontUsers: "Listado de Usuarios",
    frontLocations: "Listado de Ubicaciones",
    frontConfigs: "Listado de configuraciones",
    frontApprovedAndRejected: "Apr/Rec Servicios",
    frontSendLogistic: "Gestión logística",
    frontAgreements: "Listado de convenios",
    frontListOfRequests: "Solicitudes de convenio",
};
export const titlesNavigation = {
    listProyt: "Solicitudes Proyecto T",
    listSubscriber: "Solicitudes de suscriptor",
    listChecker: "Estado de solicitudes",
    listMyself: "Solicitudes aliados",
    listElectronic: "Certificados electrónicos",
    listRoles: "Listado de Roles",
    listConfigurations: "CONFIGURACIONES",
    listRolesAndUsers: "Usuarios y Roles",
    listSystemConfigurations: "Configuración sistema",
    listUsers: "Usuarios",
    listRolesNavigation: "Roles",
    listUbications: "Ubicaciones",
    listApprovedAndRejected: "Apr/Rec Servicios",
    listSendLogistic: "Gestión logística",
    listAgreements: "Convenios",
};

export const textIdentity = {
    notExistsInCf: "Cargar soporte desde el listado de solicitudes.",
    loadManualSupport: "Se debe validar la notificación enviada al correo electrónico registrado y cargar soporte desde el listado de solicitudes.",
    errorEvaluateQuestionnaire: "Error evaluando cuestionario",
    successEvaluateQuestionnaire: "Evaluado correctamente",
    generalErrorCf: "Error confronta",
    validationFailedVerifyAttempts: "Validación de identidad fallida, se verificara si podras intentarlo una vez mas",
    errorGettingCf: "Error obteniendo confronta",
    thirdBlocked: "Tercero bloqueado",
    noExists: "no existe",
    sendingIdentityValidationResults: "Envio de resultados de validacion de identidad",
    identityValidationPostponedByAni: "No se puede realizar validación de identidad",
    documentTypeNotApply: "Tipo de documento no aplica",
    serviceNotResponding: "Ocurrío un error, intente de nuevo",
    templateSendMail: "errorIdentityValidationCf_ECDIdentity.html",
    subjectSendMail: "GSE S.A. - Validación de identidad fallida",
    typeInSendMail: "identityValidationErrorCF",
    cfTimeout: "Tiempo de espera excedido",
    cfErrorLogin: "Error de autenticacion en Confronta",
    cfErrorTry: "Ocurrio un error, intente de nuevo",
    messageGeneralCFDianSuccess: "Confronta Validada por DIAN",
    messagePercentageCFDian: "CONFRONTACIÓN EXITOSA con 100%: ",
    noInfoDac: "No se encontró información con los datos ingresados, por favor intente nuevamente.",
    serviceUnavailableAlertTitle: "Tu solicitud no pudo ser procesada temporalmente",
    serviceUnavailableAlertText: "Estamos realizando la validación de tu información, pero uno de nuestros servicios no se encuentra disponible en este momento. Intenta nuevamente en unos minutos."
};

export const textRemedy = {
    successfullyCompleted: "¡Documento subsanado exitosamente!",
    errorOccurred: "¡Ocurrió un error, inténtelo de nuevo!",
    observationCf: "Subsanado por confronta",
    observationAni: "Subsanado por {{validationType}}",
    messageDocumentRemedyManually: "El documento fue subsanado manualmente.",
    tooltipTitleCf: "Subsanar identidad",
    tooltipTitleAni: "Subsanar identidad",
    messageAniCorrectionNotApply: "Subsanación {{validationType}} no aplica",
    templateSendMail: "rememberIdentityValidation_ECDIdentity.html",
    subjectSendMail: "GSE S.A. - Valida tu identidad",
    typeInSendMail: "identityValidationReminderCF",
    observationVIM: "Subsanado por validación de identidad manual",
};

export const textDocumentation = {
    uploadFileTextStart: "Desliza un archivo",
    uploadFileTextEnd: "aqui o",
    invalidRequestedFileFormat: "El archivo no cuenta con el formato solicitado",
    fileWithFaults: "Inconsistencia al cargar archivo",
    fileWithFaultsText: "Está intentando cargar un documento con contraseña o corrupto",
    formatNotAllowed: "Está intentando cargar un documento con un formato no permitido, solo se permiten formatos {{allowedFormats}}",
    fileSizeExceeded: "Está intentando cargar un documento con un tamaño excedido, el tamaño máximo permitido es {{allowedWeight}} MB",
    errorLoadingFile: "Ocurrió un error al cargar el archivo.",
    longFileLength: "El nombre del archivo es demasiado largo o contiene caracteres no permitidos. Por favor, asegúrate de corregirlo y vuelve a intentarlo.",
    observation: "Se aprueba verificación",
    errorLoadingRequest: "Ha ocurrido un error, inténtalo más tarde.",
};

export const textVerification = {
    observationSud: "Pasa a estado SUD desde verficacion.",
    invalidReasonForRejection: "El motivo de rechazo no es valido",
    documentIncorrectlyCorrected: "Documento Subsanado erróneamente",
    approvedDocument: "Documento Aprobado",
    observationError: "Documentos inconsistentes",
    errorOcurred: "No es posible aplazar esta solicitud"
};

export const textSubsanation = {
    descriptionWarningAPV: "Por favor, revisa detenidamente la información o la documentación proporcionada",
    descriptionWarningAPI: "Por favor, asegúrate de proporcionar tu identidad. Se han detectado problemas de verificación.",
    fieldWrong: "Campo con información errada",
    subsanationSuccess: "Certificado subsanado con éxito",
    exit: "Cancelar subsanación",
    descriptionExitText: "¿Estás seguro que deseas cancelar el proceso de subsanación?",
    saveAndContinueText: "Una vez que hayas hecho clic en 'Subsanar', la información no podrá modificarse. ¿Estás seguro de Continuar?",
    continueTitle: "Continuar subsanación",
    errorANIComparisionNames: "Los nombres registrados no corresponden al documento de identidad diligenciado",
    errorANICedula: "Cédula no existe",
    obervationOnlyDocuments: "Subsanado por documentos",
}

export const textForm = {
    finalizeSuccess: "Solicitud Radicada Exitosamente",
    finalizeError: "Error procesando la solicitud",
    partialSaveSuccess: "Guardado Parcial Exitoso",
    descriptionPartialSaveSuccess: "Haz guardado exitosamente la información parcial del formulario",
    partialSaveError: "Guardado No Exitoso",
    descriptionPartialSaveError: "No se ha podido guardar la información del formulario",
    exit: "Salir",
    descriptionExitText: "Al salir del proceso, recuerde que quedará grabada la última información que ingresó hasta el último paso que dió clic en 'Guardar y Continuar'.",
    confirmationExitText: "¿Está seguro que desea Salir?",
    noPrivileges: "No se pueden ejecutar validaciones de identidad por falta de privilegios"
};

export const textFormGeneral = {
    errorConsultAni: "Ocurrio un error, intente más tarde",
    documentCompletedByAnotherPerson: "El documento fue completado por otra persona, por favor verifique sus datos",
    sectionNotAvailableThisUser: "Esta sección no está disponible para este usuario"
}

export const OTPText = {
    emailValidation: "Validación de Email",
    emailValidationText: "Hemos enviado un código de verificación a tu correo electrónico, para continuar diligéncialo a continuación",
    notReceivedEmail: "No he recibido el email",
    emailSuccessfullyValidated: "Correo electrónico validado exitosamente",
    errorOTPSend: "Ha ocurrido un error en el envio del OTP",
    errorOTPValidate: "Codigo OTP inválido",
    errorValidateEmailGeneral: "Ocurrió un error validando el correo electrónico",
}

export const textFinalize = {
    finalizeSuccess: "Solicitud revocada exitosamente",
    finalizeError: "Error procesando la solicitud",
    doesNotHavePermissions: "Este usuario no tiene permisos para gestionar esta solicitud, contáctese con el administrador"
};

export const textFinalizeRequest = {
    successfullyCompleted: "¡Su solicitud fue finalizada satisfactoriamente!",
    problemVerifying: "Se ha presentado un inconveniente durante la verificación del certificado, por favor inténtelo más tarde.",
    requestHasAlreadyBeenFinalized: "¡La solicitud ya fue finalizada!",
    errorOccurred: "Ocurrió un error, por favor inténtelo más tarde.",
    negativeTitle: "¡Ops!",
    satisfactoryTitle: "¡Genial!"
};

export const textRevocationEcd = {
    errorOtpValidate: "Codigo OTP invalido",
    errorOtpSend: "Ha ocurrido un error un error en el envio del OTP",
    errorRevokeGeneral: "Error al realizar la consulta para la revocación",
    errorDocuments: "No se ha podido cargar el documento",
    identificationType: "Tipo de identificación es requerido",
    captchaRequired: "La validación de captcha es requerida",
    observationRequired: "La observación es requerida",
    observationMatches: "La observación no es válida",
    observationMaxLength: "La observación no puede tener más de 300 caracteres",
    causeRevocationRequired: "Motivo de revocación obligatorio",
    codeMatches: "El formato del código es incorrecto",
    codeRequired: "Código OTP es requerido",
    codeMaxLength: "El código no puede tener más de 8 caracteres",
    frontRevoke: "Consulta de estado y revocación en línea"
};

export const textAuth = {
    concurrentSession: "Iniciaste sesión desde otro dispositivo, cerrando la sesión actual.",
    errorRefreshToken: "Ha ocurrido un error",
    titleSessionExpiration: "Expiración de sesión",
    titleSessionExpire: "Tu sesión expirará",
    closeSession: "¿Necesitas más tiempo?",
    titleInactivityDetected: "¿Sigues ahí?",
    inactivityMessage: "La sesión se cerrará por inactividad. ¿Deseas continuar?",
    titleSessionWarning: "Tiempo de sesión",
    sessionWarningMessage: "¿Deseas aumentar el tiempo activo de sesión?",
    toastSessionExtended: "Tiempo aumentado",
    toastSessionExtendedMessage: "El tiempo de sesión se aumentó exitosamente.",
    sessionTitle: "Sesión:",
    inactivityTitle: "Inactividad:"
};

export const textUsersAndRoles = {
    userCreate: "El usuario fue creado exitosamente",
    userFailed: "El usuario no fue creado correctamente",
    userUpdate: "El usuario fue Actualizado Exitosamente",
    userFailedUpdate: "El usuario no fue Actualizado Exitosamente",
    save: "¿Deseas guardar los cambios realizados?",
    saveCancel: "Si cancelas, perderás los cambios realizados, ¿deseas continuar ?",
    nameRequired: "Los nombres son requerido",
    nameValidation: "Los nombres no son validos",
    nameMaxLength: "Los nombres no pueden tener más de 255 caracteres",
    lastNameRequired: "Los apellidos son requeridos",
    lastnNameValidation: "El apellido no es valido",
    lastNameMaxLength: "Los apellidos no pueden tener más de 300 caracteres",
    documentNumberRequired: "El numero de documento es requerido",
    documentNumberValidation: "El numero de documento no es valido",
    documentNumberMaxLength: "El numero de documento no puede tener más de 300 caracteres",
    emailRequired: "El correo electrónico es requerido",
    emailValidation: "El correo electrónico no es válido",
    emailMinLength: "Debe tener al menos 3 caracteres",
    emailMaxLength: "El correo electrónico no puede tener más de 300 caracteres",
    emailDomainInvalid: 'El dominio de este correo no está permitido',
    nameRolRequired: "El nombre del rol es requerido",
    nameRolValidation: "El nombre del rol no es valido",
    nameRolMaxLength: "El nombre del rol no puede tener más de 255 caracteres",
    descriptionRolRequired: "La descripción del rol es requerida",
    descriptionRolValidation: "La descripción del rol no es valida",
    descriptionRolMinLength: "Debe tener al menos 3 caracteres",
    descriptionRolMaxLength: "La descripción del rol no puede tener más de 100 caracteres",
    roleCreate: "El rol fue creado Exitosamente",
    roleFailed: "El rol no fue creado Correctamente",
    roleUpdate: "El rol fue Actualizado Exitosamente",
    roleFailedUpdate: "El rol no fue Actualizado Correctamente",
    allowedCharacters: `Caracteres permitidos: .-'\°&+?()/´¿#\`$%:!@_{}*>;[]^|~¡¥®`
};

export const textGeneral = {
    textNotFound: "No es posible cargar la información, por favor intente más tarde.",
    textResendFailed: "No podemos enviar la información al correo proporcionado en este momento. Por favor, inténtelo nuevamente más tarde.",
    textResendSuccess: "Hemos generado su reenvío de forma exitosa.",
    textImportantInfo: "Información importante",
    textOpenNewTab: "Abrir en nueva ventana",
    validationNotFound: "Error consultando información, por favor intente de nuevo",
    infoNotFound: "No es posible cargar la información, por favor intente más tarde.",
    textNotFoundVerification: "No es posible cargar la información, por favor intente nuevamente.",
};

export const textFormIndex = {
    messageTycMandatory: "Debes completar los TyC antes de continuar.",
    messageDocMandatory: "Debes completar los TyC y la Documentación antes de continuar.",
    TitleCertificate: "Tramita tu firma acreditada",
    TitleSubsanation: "Subsanar certificado",
    imageUploadText: "No se ha subido una imagen",
    buttonImageUpload: "Capturar",
};

export const textRevokeGSE = {
    errorVerification: "Ha ocurrido un error al enviar el código de verificación",
    validateOTP: "Ha ocurrido un error al validar el código de verificación",
    errorConsult: "Ha ocurrido un error en la validación de la información",
    notResult: "No se encontraron resultados",
    errorConsultRevoke: "Ha ocurrido un error al consultar la información",

}

export const textConfigurations = {
    mandatoryField: "El campo es obligatorio",
    configurationUpdate: "La configuración fue actualizada exitosamente",
    configurationFailedUpdate: "La configuración no fue actualizada exitosamente",
}

export const textCredentials = {
    credentialsSuccess: "Registro de credenciales exitoso",
    credentialsError: "Credenciales no válidas",
    credentialsUpdateSuccess: "Actualización de credenciales exitosa"
}

export const textRequestManagement = {
    eventAprSucess: "Aprobado exitosamente",
    eventRczSucess: "Rechazado exitosamente",
    eventVLDSucess: "Validado exitosamente",
    eventEMCSuccess: "Emitido exitosamente",
    eventSuccess: "Evento Registrado Satisfactoriamente",
    errorEMCEvent: "Ocurrio un error emitiendo el evento",
    errorRegisterEvent: "Ocurrio un error registrando el evento",
    errorApproveCertificate: "Ocurrio un error aprobando el certificado",
    errorResend: "Ha ocurrido un error en el reenvío, por favor intente nuevamente",
    secondAttempt: "Crear segundo intento",
    messageIssue: "Emitir",
    messageIssueExceptionBiometrix: "Emitir Excepcion",
    historicTitle: "Generación de firmas electrónicas certificadas",
}
export const textLogistic = {
    firstSelect: "Tokens Emitidos",
    secondSelect: "Guías Servientrega",
    thirdSelect: " Gestionados",
    fourthSelect: "Cola",
    tittleModalManifest: "Datos de repartidor",
    genereteGuide: "Generar Guía",
    genereteGuideMasive: "Generar Guía Masivo",
    titleDeliveryConfirm: "Confirmación de Entrega",
    buttonDeliverySave: "Confirmar Entrega",
    buttonDeliveryCancel: "Cancelar",
    errorConfirmDelivery: "Error en la confirmacion de entrega",
    updateLocation: "Actualizar Ubicación",
    forwardingTitle: "Realizar reenvío",
    errorResendQueue: "Error reenviado cola",
}

export const textPrint = {
    errorConsumptionBiomanager: "Error al consumir servicio de Biomanager",
    errorRegisterInfo: "Error registrando información de impresión",
    successRegisterInfo: "Información de impresión registrada exitosamente",
    errorPrintGeneral: "Ocurrió un error en la impresión",
    successPrintGeneral: "Impresión SobreFlex exitosa"
}

export const textCancelGuide = {
    errorCancelGuide: "Error al anular la guía",
    successCancelGuide: "Guía anulada exitosamente",
    errorGenereteGuide: "Error al realizar la generación de la guía",
    errorConsultFile: "Error al consultar el archivo",
}

export const textServientregaMassive = {
    errorGenereteServientrega: "Masivo de guías fallido",
    successGenerateServientrega: "Masivo de guías enviado exitosamente",
    errorMaxBatchSize: "Masivo de guias Servientrega supera el tamaño máximo permitido de registros seleccionados",
}

export const textRequestAssignments = {
    csrUploadLabel: "Adjuntar documento .csr",
    xroadTemporaryUnavailableTitle: "Tu solicitud no pudo ser procesada temporalmente",
    xroadTemporaryUnavailableText: "Ocurrió un error al momento de intentar asignar la solicitud. Intenta nuevamente en unos minutos.",
    tooltipAssignment: "Asignar",
    titleModalAssignment: "Asignación de solicitudes",
    noExistsProducts: "No existen productos asociados a este contrato",
    errorByConsultGeneralPopup: "Ocurrió un error al cargar los datos, intente más tarde",
    errorInRegisterRequest: "Ocurrió un error al registrar la solicitud",
    errorInUpdateAmountContract: "Ocurrió un error al realizar la asignación de la solicitud y descontar el cupo",
    errorInConsultDeliveryMethod: "Ocurrió un error al consultar el tipo de entrega",
    successAssignment: "Solicitud asignada exitosamente",
    observationRejected: "Rechazo por error en descuento de cupos",
    tooltipAssociate: "Asociar Supervisor",
    tittleModalAssociate: "Asociar Supervisor",
    associateSuccess: "Supervisor asociado con éxito",
    associateError: "Ocurrió un error al asociar el supervisor",
    allowedCharacters: `Caracteres permitidos: .-'\°&+?()/´¿#\`$%:!@_{}*>;[]^|~¡¥®`
}

export const textEmission = {
    errorConsultEmission: "Error al consultar la emisión",
    errorConsultSerial: "Error al consultar el serial del token",
    errorConsultValidationSerial: "Error al consultar la validación del serial del token",
    errorIssueCertificate: "Error al realizar la emisión del certificado",
    errorConsultSerialBusy: "El serial está asignado a una solicitud vigente",
    errorImportSerial: "Error al importar la información del serial",
};

export const textValidationVIM = {
    buttonValContinue: "Validar Identidad y continuar",
    buttonContinue: "Continuar",
    buttonAPL: "Aplazar",
    buttonVal: "Identidad validada",
    textTitleVIM: "Validación de identidad",
    textValVIM: "¿Desea validar la identidad del suscriptor?",
    textRequestAplSuccess: "Solicitud aplazada exitosamente",
    textRequestValSuccess: "Solicitud validada exitosamente",
    textErrorRequestRegisterVIM: "Ocurrió un error al registrar el estado",
    nameInStepByStepVIM: "Validación de identidad manual",
}

export const formFieldsAssignment = {
    labelProducts: "Productos",
    labelDocumentType: "Tipo de documento",
    labelDocumentNumber: "Número de documento",
    labelFirstName: "Primer nombre",
    labelSecondName: "Segundo nombre",
    labelFirstLastName: "Primer apellido",
    labelSecondLastName: "Segundo apellido",
    labelEmail: "Correo electrónico"
};

export const formFieldsAssociateSupervisor = {
        labelDocumentType: "Tipo de documento",
        labelDocumentNumber: "Número de documento",
        labelNames: "Nombres",
        labelLastNames: "Apellidos",
        labelAddress: "Dirección",
        labelCountry: "País",
        labelDepartment: "Departamento",
        labelMunicipality: "Municipio",
        labelEmail: "Correo electrónico"
};

export const headerMessages ={
    verificationSection: "Las solicitudes están filtradas por la fecha de registro. Si necesitas ver otras fechas, puedes hacerlo desde los campos <b>“Registrado el”</b> o <b>“Actualizado el”</b>.",
    clientSection: "Las solicitudes están filtradas por la <b>“Fecha de Asignación”</b> de la más reciente a la más antigua.",
    myselfSection: "Las solicitudes están filtradas por la fecha de asignación. Si necesitas ver otras fechas, puedes hacerlo desde los campos <b>“Fecha de Asignación”</b> o <b>“Fecha y Hora último estado”</b>.",
    requestManagementSection: "Las solicitudes están filtradas por la fecha de cambio de último estado. Si necesitas ver otras fechas, puedes hacerlo desde los campos <b>“Fecha Último estado”</b>.",
    conveniosSection:"Las solicitudes están filtradas por la fecha de inicio. Si necesitas ver otras fechas, puedes hacerlo desde los campos <b>“Fecha Inicio”</b>.",
    listRequestSection: "Las solicitudes están filtradas por el numero de documento. Si necesitas ver otras documentos, puedes hacerlo desde los campos <b>“No. Documento”</b>.", 
}

export const textRevokeRequest = {
    titleModal: "Revocación de solicitud",
    codeRequired: "El código Zoho es requerido",
    codeInvalid: "El código Zoho no es válido",
    codeMaxLength: "El código Zoho excede el máximo de 15 caracteres",
    observationRequired: "La observación es requerida",
    observationMaxLength: "La observación no puede tener más de 300 caracteres",
    observationMatches: "La observación no es válida",
    causeRevocationRequired: "El motivo de revocación es obligatorio",
    causeRevocationInvalid: "El motivo de revocación no es válido",
    captchaRequired: "La validación de captcha es requerida",
    reasonRequired: "El motivo de revocación es requerido",
    revokeSuccess: "Solicitud revocada exitosamente",
    revokeError: "Error procesando la solicitud",
    errorConsultTyc: "Ocurrió un error consultando términos y condiciones",
    titleConfirm: "Revocación de solicitud",
    messageConfirmation: "¿Está seguro que desea revocar la solicitud?",
    errorSendRevoke: "Error al enviar la solicitud de revocación",
    successSendRevoke: "Se ha revocado exitosamente",
};

export const textForwardNotification = {
    successForwardNotification: "Reenvió generado exitosamente",
    serviceUnavailableAlertTitle: "Tu solicitud no pudo ser procesada temporalmente",
    serviceUnavailableAlertText: "Estamos realizando la validación de tu información, pero uno de nuestros servicios no se encuentra disponible en este momento. Intenta nuevamente en unos minutos."
}
